module.exports = __webpack_public_path__ + "img/transfer.05382c44.svg";